// Compra Rápida (sections/compra-rapida.liquid). Configuração da loja vem dos atributos data- da
// gaveta (data-pix-percentage, data-guide) e o carrinho inicial de window.cart, definido na seção.
(() => {
  const initQuickOrder = () => {
    const drawer = document.querySelector('.compra-rapida-dmg');
    if (!drawer || drawer.dataset.quickOrderReady === 'true') return;
    drawer.dataset.quickOrderReady = 'true';

    const list = drawer.querySelector('.lista-compra-rapida');
    const sections = [...drawer.querySelectorAll('.section-items')];
    const categoryNavigation = drawer.querySelector('.navegacao-compra-rapida');
    const categoryScrollShell = drawer.querySelector('[data-category-scroll-shell]');
    const categoryScrollbar = drawer.querySelector('[data-category-scrollbar]');
    const categoryScrollPrevious = drawer.querySelector('[data-category-scroll-direction="-1"]');
    const categoryScrollNext = drawer.querySelector('[data-category-scroll-direction="1"]');
    const categoryButtons = [...drawer.querySelectorAll('.seletor-compra')];
    const searchInput = drawer.querySelector('[data-quick-order-search]');
    const searchClearButtons = [...drawer.querySelectorAll('[data-clear-search]')];
    const emptyState = drawer.querySelector('[data-quick-order-empty]');
    const emptyQuery = drawer.querySelector('[data-empty-query]');
    const addButton = drawer.querySelector('[compra-rapida-add]');
    const clearSelectionButton = drawer.querySelector('[data-clear-selection]');
    const footerActions = drawer.querySelector('.footer-compra-rapida-actions');
    const selectionSummaryLabel = drawer.querySelector('[data-selection-summary-label]');
    const totalElement = drawer.querySelector('[total-compra-rapida]');
    const pixSummary = drawer.querySelector('[data-pix-summary]');
    const pixTotal = drawer.querySelector('[data-pix-total]');
    const liveRegion = drawer.querySelector('[data-quick-order-live]');
    const feedback = drawer.querySelector('[data-quick-order-feedback]');
    const feedbackMessage = drawer.querySelector('[data-feedback-message]');
    const feedbackActions = drawer.querySelector('[data-feedback-actions]');
    const loadingState = drawer.querySelector('[data-quick-order-loading]');
    const loadingMessage = drawer.querySelector('[data-quick-order-loading-message]');
    const retryButton = drawer.querySelector('[data-quick-order-retry]');
    const pixPercentage = Number(drawer.dataset.pixPercentage) || 0;
    const guideEnabled = drawer.dataset.guide === 'true';
    let activeCategory = 'all';
    let opener = null;
    let adding = false;
    let categoryScrollFrame = null;
    let introAssetsPromise = null;
    let introGuideStarting = false;
    let loadingPromise = null;
    let loadingFinalized = false;
    let scheduledWork = null;
    let schedulerGeneration = 0;
    let fetchActive = false;
    let workRunning = false;
    let urgent = false;
    let mediaBuffering = false;
    let pageLoaded = document.readyState === 'complete';
    const bufferingMedia = new Set();
    const jobs = sections.map((section, index) => ({
      section,
      index,
      count: Number.parseInt(section.dataset.productsCount, 10) || 0,
      state: 'queued',
      rows: [],
      cursor: 0,
      error: null
    }));

    const introAssets = {
      script: 'https://cdn.jsdelivr.net/npm/intro.js@7.2.0/intro.min.js',
      stylesheet: 'https://cdn.jsdelivr.net/npm/intro.js@7.2.0/minified/introjs.min.css'
    };

    const loadIntroAssets = () => {
      if (typeof window.introJs === 'function') return Promise.resolve();
      if (introAssetsPromise) return introAssetsPromise;

      const loadStylesheet = new Promise((resolve, reject) => {
        const existing = document.querySelector('link[data-dm-intro-stylesheet]');
        if (existing) {
          if (existing.sheet) resolve();
          else {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
          }
          return;
        }

        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = introAssets.stylesheet;
        stylesheet.dataset.dmIntroStylesheet = 'true';
        stylesheet.addEventListener('load', resolve, { once: true });
        stylesheet.addEventListener('error', () => {
          stylesheet.remove();
          reject(new Error('Falha ao carregar os estilos do guia.'));
        }, { once: true });
        document.head.append(stylesheet);
      });

      const loadScript = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-dm-intro-script]');
        if (existing) {
          if (typeof window.introJs === 'function') resolve();
          else {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
          }
          return;
        }

        const script = document.createElement('script');
        script.src = introAssets.script;
        script.async = true;
        script.dataset.dmIntroScript = 'true';
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', () => {
          script.remove();
          reject(new Error('Falha ao carregar o script do guia.'));
        }, { once: true });
        document.head.append(script);
      });

      introAssetsPromise = Promise.all([loadStylesheet, loadScript]).catch((error) => {
        introAssetsPromise = null;
        throw error;
      });
      return introAssetsPromise;
    };

    const startIntroGuide = () => {
      if (introGuideStarting || localStorage.getItem('primeiroAcesso')) return;
      introGuideStarting = true;

      loadIntroAssets()
        .then(() => {
          if (!isOpen() || typeof window.introJs !== 'function') {
            introGuideStarting = false;
            return;
          }
          window.introJs()
            .setOption('nextLabel', 'Próximo')
            .setOption('prevLabel', 'Anterior')
            .setOption('doneLabel', 'Fechar')
            .start();
          localStorage.setItem('primeiroAcesso', 'true');
        })
        .catch((error) => {
          introGuideStarting = false;
          console.warn('Não foi possível carregar o guia da compra rápida.', error);
        });
    };

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const backgroundAllowed = () => (
      pageLoaded
      && document.visibilityState === 'visible'
      && navigator.onLine !== false
      && !connection?.saveData
      && (!connection?.effectiveType || connection.effectiveType === '4g')
    );

    const inputPending = () => (
      typeof navigator.scheduling?.isInputPending === 'function'
      && (() => {
        try {
          return navigator.scheduling.isInputPending({ includeContinuous: true });
        } catch (error) {
          return navigator.scheduling.isInputPending();
        }
      })()
    );

    const mediaBlocksBackground = () => {
      document.querySelectorAll('video, audio').forEach((media) => {
        if (!media.paused && !media.ended && media.readyState < 3) bufferingMedia.add(media);
      });
      bufferingMedia.forEach((media) => {
        if (!media.isConnected || media.paused || media.ended || media.readyState >= 3) {
          bufferingMedia.delete(media);
        }
      });
      mediaBuffering = bufferingMedia.size > 0;
      return mediaBuffering;
    };

    const isOpen = () => document.body.classList.contains('compra-rapida-aberto');

    const updateLoadingState = () => {
      const readyCount = jobs.filter((job) => job.state === 'ready').length;
      const failedCount = jobs.filter((job) => job.state === 'error').length;
      const settledCount = readyCount + failedCount;
      const complete = settledCount === jobs.length;
      const hasRows = drawer.querySelector('[data-quick-order-row]') !== null;
      const readyToReveal = complete && failedCount === 0 && hasRows;

      const busy = String(!complete);
      if (list.getAttribute('aria-busy') !== busy) list.setAttribute('aria-busy', busy);
      if (list.hidden !== !readyToReveal) list.hidden = !readyToReveal;
      const terminalFailure = failedCount > 0 && complete;
      const emptyCatalog = complete && !failedCount && !hasRows;
      if (loadingState.hidden !== readyToReveal) loadingState.hidden = readyToReveal;
      const terminal = terminalFailure || emptyCatalog;
      if (loadingState.classList.contains('is-terminal') !== terminal) {
        loadingState.classList.toggle('is-terminal', terminal);
      }

      if (loadingMessage) {
        const message = terminalFailure
          ? 'Não foi possível preparar todos os produtos.'
          : emptyCatalog
            ? 'Nenhum produto disponível no momento.'
            : 'Preparando a Compra Rápida…';
        if (loadingMessage.textContent !== message) loadingMessage.textContent = message;
      }
      if (retryButton && retryButton.hidden !== !terminalFailure) {
        retryButton.hidden = !terminalFailure;
      }

      const contentReady = String(complete && failedCount === 0);
      if (drawer.dataset.quickOrderContentReady !== contentReady) {
        drawer.dataset.quickOrderContentReady = contentReady;
      }
      return { complete, hasRows, failedCount, emptyCatalog };
    };

    const cancelScheduledWork = () => {
      schedulerGeneration += 1;
      if (!scheduledWork) return;
      if (scheduledWork.type === 'idle') window.cancelIdleCallback(scheduledWork.id);
      if (scheduledWork.type === 'timeout') window.clearTimeout(scheduledWork.id);
      scheduledWork = null;
    };

    const scheduleWork = (callback, { immediate = false } = {}) => {
      if (scheduledWork) return;
      const generation = schedulerGeneration;
      const run = (deadline) => {
        scheduledWork = null;
        if (generation !== schedulerGeneration) return;
        callback(deadline || null);
      };

      if (immediate) {
        scheduledWork = { type: 'timeout', id: window.setTimeout(() => run(null), 0) };
        return;
      }

      const scheduleFallback = () => {
        if (typeof window.requestIdleCallback === 'function') {
          scheduledWork = {
            type: 'idle',
            id: window.requestIdleCallback(run, { timeout: 2000 })
          };
          return;
        }

        scheduledWork = { type: 'timeout', id: window.setTimeout(() => run(null), 50) };
      };

      if (typeof window.scheduler?.postTask === 'function') {
        const token = { type: 'task' };
        scheduledWork = token;
        window.scheduler.postTask(() => {
          if (scheduledWork !== token) return;
          run(null);
        }, { priority: 'background' }).catch(() => {
          if (scheduledWork !== token) return;
          scheduledWork = null;
          scheduleFallback();
        });
        return;
      }

      scheduleFallback();
    };

    const nextFetchJob = () => {
      const queued = jobs.filter((job) => job.state === 'queued');
      if (!queued.length) return null;
      if (urgent) return queued[0];

      const first = queued.find((job) => job.index === 0);
      if (first) return first;
      return queued.sort((a, b) => b.count - a.count || a.index - b.index)[0];
    };

    const decorateRow = (row, job) => {
      const categoryTitle = job.section.dataset.categoryTitle || '';
      row.dataset.searchText = `${row.dataset.searchText || ''} ${categoryTitle}`.trim();
      const variantToggle = row.querySelector('[data-variant-toggle][aria-controls]');
      const variants = row.querySelector('.item-compra-rapida-variants[id]');
      if (variantToggle && variants) {
        const uniqueId = `${variants.id}-${job.index}`;
        variants.id = uniqueId;
        variantToggle.setAttribute('aria-controls', uniqueId);
      }
    };

    const hydrateSlice = (deadline = null) => {
      if (!urgent && inputPending()) return false;
      const job = jobs.find((item) => item.state === 'fetched' || item.state === 'hydrating');
      if (!job) return false;

      if (job.cursor >= job.rows.length) {
        job.state = 'ready';
        job.rows = [];
        return false;
      }

      job.state = 'hydrating';
      const target = job.section.querySelector('.section-products');
      if (!target) {
        job.state = 'error';
        job.error = new Error('Destino dos produtos não encontrado.');
        job.rows = [];
        return false;
      }
      const fragment = document.createDocumentFragment();
      const startedAt = performance.now();
      const maximum = urgent ? 8 : 4;
      let inserted = 0;

      while (job.cursor < job.rows.length && inserted < maximum) {
        const hasIdleBudget = !deadline || deadline.didTimeout || deadline.timeRemaining() > 5;
        const hasFrameBudget = performance.now() - startedAt < (urgent ? 8 : 4);
        if (inserted > 0 && (!hasIdleBudget || !hasFrameBudget || inputPending())) break;

        let row = null;
        try {
          const template = document.createElement('template');
          template.innerHTML = job.rows[job.cursor].trim();
          row = template.content.firstElementChild;
          if (!row?.matches('[data-quick-order-row]')) {
            throw new Error('Produto inválido na resposta da Compra Rápida.');
          }
        } catch (error) {
          job.state = 'error';
          job.error = error;
          job.rows = [];
          console.warn('Não foi possível montar um produto da Compra Rápida.', error);
          return false;
        }
        decorateRow(row, job);
        fragment.append(row);
        job.cursor += 1;
        inserted += 1;
      }

      if (inserted) {
        fragment.querySelectorAll('cart-update-compra-rapida input.quantity').forEach(syncQuantityState);
        target.append(fragment);
        job.section.hidden = false;
        const categoryButton = categoryButtons.find((button) => (
          button.dataset.targetSection === job.section.dataset.linha
        ));
        if (categoryButton) categoryButton.hidden = false;
        requestCategoryScrollbarSync();
      }

      if (job.cursor >= job.rows.length) {
        job.state = 'ready';
        job.rows = [];
      }
      return inserted > 0;
    };

    const parseJobResponse = (job, html) => {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const payload = documentFragment.querySelector('[data-quick-order-payload]');
      if (!payload) throw new Error('Resposta de produtos inválida.');
      const rows = JSON.parse(payload.textContent || '[]');
      if (!Array.isArray(rows)) throw new Error('Lista de produtos inválida.');
      job.rows = rows;
      job.cursor = 0;
      job.state = 'fetched';
    };

    const fetchJob = async (job) => {
      fetchActive = true;
      job.state = 'fetching';
      job.error = null;
      try {
        const options = {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        };
        try { options.priority = urgent ? 'high' : 'low'; } catch (error) {}
        const response = await fetch(job.section.dataset.loadUrl, options);
        if (!response.ok) throw new Error(`Falha ao carregar produtos (${response.status}).`);
        parseJobResponse(job, await response.text());
      } catch (error) {
        job.state = 'error';
        job.error = error;
        console.warn('Não foi possível preparar uma categoria da Compra Rápida.', error);
      } finally {
        fetchActive = false;
      }
    };

    const startJobFetch = (job) => {
      fetchJob(job).finally(() => {
        updateLoadingState();
        if (!allSettled() && (urgent || backgroundAllowed())) {
          scheduleWork(runWork, { immediate: urgent });
        } else if (allSettled()) {
          finishLoading();
        }
      });
    };

    const allSettled = () => jobs.every((job) => job.state === 'ready' || job.state === 'error');

    const syncGuideMarker = () => {
      if (guideEnabled) {
        drawer.querySelectorAll('.quantity-compra-rapida[data-intro]').forEach((element) => {
          element.removeAttribute('data-intro');
        });
        const firstQuantity = [...drawer.querySelectorAll('.section-items .quantity-compra-rapida')]
          .find((element) => (
            element.isConnected
            && !element.closest('[hidden]')
            && element.getClientRects().length > 0
          ));
        if (firstQuantity) firstQuantity.dataset.intro = 'Selecione a quantidade de cada item';
      }
    };

    const finishLoading = () => {
      if (loadingFinalized) return;
      const state = updateLoadingState();
      if (!state.complete) return;
      // Fetch completion and scheduled hydration can settle the same cycle.
      loadingFinalized = true;
      if (state.hasRows) applyFilters();
      syncGuideMarker();
      calculateSelection();
      requestCategoryScrollbarSync();
      if (loadingPromise) loadingPromise.resolve(state);
    };

    const runWork = (deadline = null) => {
      if (workRunning) return;
      workRunning = true;
      try {
        if (!urgent && !backgroundAllowed()) return;

        hydrateSlice(deadline);
        updateLoadingState();

        if (!fetchActive && (urgent || !mediaBlocksBackground())) {
          const job = nextFetchJob();
          if (job) {
            startJobFetch(job);
          }
        }

        if (allSettled()) {
          finishLoading();
          return;
        }

        const hasHydrationWork = jobs.some((job) => job.state === 'fetched' || job.state === 'hydrating');
        if (hasHydrationWork) {
          scheduleWork(runWork, { immediate: urgent });
        } else if (!fetchActive && !mediaBlocksBackground()) {
          scheduleWork(runWork, { immediate: urgent });
        }
      } finally {
        workRunning = false;
      }
    };

    const ensureContent = ({ priority = 'background' } = {}) => {
      if (allSettled()) return Promise.resolve(updateLoadingState());
      if (!loadingPromise) {
        loadingPromise = {};
        loadingPromise.promise = new Promise((resolve) => { loadingPromise.resolve = resolve; });
      }
      if (priority === 'user-visible') {
        urgent = true;
        cancelScheduledWork();
      }
      scheduleWork(runWork, { immediate: urgent });
      return loadingPromise.promise;
    };

    const normalize = (value = '') => value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('pt-BR')
      .trim();

    const moneyFormat = drawer.dataset.moneyFormat || window.money_format;
    const mobileLayout = window.matchMedia('(max-width: 767px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const formatMoney = (cents) => (
      window.Shopify.formatMoney(Math.max(0, Number(cents) || 0), moneyFormat)
    );

    const announce = (message) => {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      window.setTimeout(() => {
        liveRegion.textContent = message;
      }, 20);
    };

    const resetFeedback = () => {
      if (!feedback) return;
      feedback.hidden = true;
      if (feedbackMessage) feedbackMessage.textContent = '';
      if (feedbackActions) feedbackActions.hidden = true;
    };

    const syncCategoryScrollbar = () => {
      if (!categoryNavigation) return;
      const viewportWidth = categoryNavigation.clientWidth;
      const contentWidth = categoryNavigation.scrollWidth;
      const maxScroll = Math.max(0, contentWidth - viewportWidth);
      const hasOverflow = maxScroll > 2;
      const scrollPosition = Math.max(0, Math.min(maxScroll, categoryNavigation.scrollLeft));
      const progress = maxScroll > 0 ? scrollPosition / maxScroll : 0;

      const canScrollLeft = hasOverflow && scrollPosition > 2;
      const canScrollRight = hasOverflow && scrollPosition < maxScroll - 2;

      categoryScrollShell?.classList.toggle('can-scroll-left', canScrollLeft);
      categoryScrollShell?.classList.toggle('can-scroll-right', canScrollRight);

      if (categoryScrollPrevious) {
        categoryScrollPrevious.hidden = !canScrollLeft;
        categoryScrollPrevious.disabled = !canScrollLeft;
      }
      if (categoryScrollNext) {
        categoryScrollNext.hidden = !canScrollRight;
        categoryScrollNext.disabled = !canScrollRight;
      }

      if (!categoryScrollbar) return;
      categoryScrollbar.hidden = !hasOverflow;
      if (!hasOverflow) {
        categoryScrollbar.max = '0';
        categoryScrollbar.value = '0';
        return;
      }

      const thumbWidth = Math.max(
        44,
        Math.round(viewportWidth * (viewportWidth / contentWidth))
      );

      categoryScrollbar.max = String(Math.ceil(maxScroll));
      categoryScrollbar.value = String(Math.round(scrollPosition));
      categoryScrollbar.style.setProperty(
        '--dm-category-scroll-thumb-width',
        `${Math.min(viewportWidth, thumbWidth)}px`
      );
      categoryScrollbar.setAttribute(
        'aria-valuetext',
        progress <= .02 ? 'Início' : progress >= .98 ? 'Fim' : `${Math.round(progress * 100)}%`
      );
    };

    const requestCategoryScrollbarSync = () => {
      if (categoryScrollFrame) window.cancelAnimationFrame(categoryScrollFrame);
      categoryScrollFrame = window.requestAnimationFrame(() => {
        categoryScrollFrame = null;
        syncCategoryScrollbar();
      });
    };

    const getInputs = () => [...drawer.querySelectorAll('cart-update-compra-rapida input.quantity')];

    const syncQuantityState = (input) => {
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      const control = input.closest('cart-update-compra-rapida');
      const minus = control?.querySelector('[data-minus-quantity-cart]');
      const row = input.closest('.item-compra-rapida');

      input.value = String(quantity);
      input.classList.toggle('zero', quantity === 0);
      if (minus) minus.disabled = quantity === 0;
      if (row) row.classList.toggle('is-selected', quantity > 0);
    };

    const calculateSelection = () => {
      let itemCount = 0;
      let total = 0;

      getInputs().forEach((input) => {
        syncQuantityState(input);
        const quantity = Number.parseInt(input.value, 10) || 0;
        const price = Number.parseInt(input.dataset.price, 10) || 0;
        itemCount += quantity;
        total += quantity * price;
      });

      const hasSelection = itemCount > 0;
      const itemWord = itemCount === 1 ? 'item' : 'itens';

      if (selectionSummaryLabel) {
        selectionSummaryLabel.textContent = mobileLayout.matches
          ? 'Total:'
          : hasSelection
            ? `${itemCount} ${itemWord} · Total:`
            : 'Total:';
      }
      totalElement.textContent = formatMoney(total);
      addButton.disabled = !hasSelection || adding;
      addButton.classList.toggle('is-loading', adding);
      addButton.setAttribute('aria-busy', String(adding));
      addButton.textContent = adding
        ? mobileLayout.matches
          ? 'Adicionando...'
          : `Adicionando ${itemCount} ${itemWord}...`
        : hasSelection
          ? mobileLayout.matches
            ? 'Adicionar ao carrinho'
            : `Adicionar ${itemCount} ${itemWord} ao carrinho`
          : 'Selecione ao menos 1 produto';
      clearSelectionButton.hidden = adding || (!mobileLayout.matches && !hasSelection);
      clearSelectionButton.disabled = !hasSelection || adding;
      if (footerActions) {
        footerActions.hidden = mobileLayout.matches && adding;
      }

      if (pixSummary && pixTotal) {
        pixSummary.hidden = !hasSelection || pixPercentage <= 0;
        pixTotal.textContent = formatMoney(Math.round(total * (1 - (pixPercentage / 100))));
      }

      if (totalElement.animate && !reducedMotion.matches) {
        totalElement.animate(
          [{ opacity: .55, transform: 'translateY(2px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 160, easing: 'ease-out' }
        );
      }

      return { itemCount, total };
    };

    const applyFilters = () => {
      const query = normalize(searchInput.value);
      let visibleRows = 0;

      drawer.classList.toggle('is-category-filtered', activeCategory !== 'all');

      categoryButtons.forEach((button) => {
        const selected = button.dataset.targetSection === activeCategory;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-selected', String(selected));
      });

      sections.forEach((section) => {
        const categoryMatches = activeCategory === 'all' || section.dataset.linha === activeCategory;
        let sectionVisibleRows = 0;
        const rows = [...section.querySelectorAll(':scope > .section-products > [data-quick-order-row]')];

        rows.forEach((row) => {
          const textMatches = !query || normalize(row.dataset.searchText).includes(query);
          const visible = categoryMatches && textMatches;
          row.hidden = !visible;
          if (visible) sectionVisibleRows += 1;
        });

        section.hidden = sectionVisibleRows === 0;
        visibleRows += sectionVisibleRows;
      });

      searchClearButtons.forEach((button) => {
        if (button.classList.contains('dm-search-clear')) button.hidden = !query;
      });

      const contentReady = drawer.dataset.quickOrderContentReady === 'true';
      emptyState.hidden = !contentReady || visibleRows > 0;
      list.hidden = !contentReady || visibleRows === 0;
      if (emptyQuery) emptyQuery.textContent = searchInput.value.trim();
    };

    const ensureCategoryVisible = (button) => {
      if (!button || !categoryNavigation || !mobileLayout.matches) return;
      const navigationRect = categoryNavigation.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();
      const leftInset = categoryScrollShell?.classList.contains('can-scroll-left') ? 44 : 0;
      const rightInset = categoryScrollShell?.classList.contains('can-scroll-right') ? 44 : 0;
      let delta = 0;

      if (buttonRect.left < navigationRect.left + leftInset) {
        delta = buttonRect.left - navigationRect.left - leftInset;
      } else if (buttonRect.right > navigationRect.right - rightInset) {
        delta = buttonRect.right - navigationRect.right + rightInset;
      }

      if (Math.abs(delta) > 1) {
        categoryNavigation.scrollBy({ left: delta, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
    };

    const setCategory = (category) => {
      activeCategory = category || 'all';
      applyFilters();
      ensureCategoryVisible(categoryButtons.find((button) => button.dataset.targetSection === activeCategory));
      requestCategoryScrollbarSync();
      list.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    const finishOpenWhenReady = (state) => {
      if (!isOpen()) return;
      if (state.complete) drawer.setAttribute('aria-busy', 'false');
      if (state.failedCount || !state.hasRows) return;
      if (guideEnabled) startIntroGuide();
    };

    const openDrawer = (trigger) => {
      opener = trigger || document.activeElement;
      document.body.classList.add('compra-rapida-aberto');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-busy', String(drawer.dataset.quickOrderContentReady !== 'true'));
      resetFeedback();
      ensureContent({ priority: 'user-visible' }).then(finishOpenWhenReady);
      window.setTimeout(() => {
        if (!isOpen()) return;
        drawer.querySelector('[fechar-compra-rapida]')?.focus({ preventScroll: true });
        requestCategoryScrollbarSync();
      }, 60);
    };

    const closeDrawer = ({ restoreFocus = true } = {}) => {
      document.body.classList.remove('compra-rapida-aberto');
      drawer.setAttribute('aria-hidden', 'true');
      if (!allSettled()) {
        urgent = false;
        cancelScheduledWork();
        ensureContent();
      }
      if (restoreFocus && opener && typeof opener.focus === 'function') {
        window.setTimeout(() => opener.focus(), 50);
      }
    };

    const focusableElements = () => [...drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => !element.hidden && element.offsetParent !== null);

    const changeQuantity = (button, delta) => {
      if (adding || button.disabled) return;
      const control = button.closest('cart-update-compra-rapida');
      const input = control?.querySelector('input.quantity');
      if (!input) return;

      const variantId = Number.parseInt(control.dataset.variant, 10);
      const inventory = Number.parseInt(control.dataset.inventory, 10) || 0;
      const inCart = (window.cart?.items || []).find((item) => item.variant_id === variantId)?.quantity || 0;
      const available = Math.max(0, inventory - inCart);
      const current = Number.parseInt(input.value, 10) || 0;
      const next = Math.max(0, Math.min(current + delta, available));

      if (delta > 0 && next === current && current >= available) {
        announce('Quantidade máxima disponível atingida.');
        return;
      }

      input.value = String(next);
      syncQuantityState(input);
      resetFeedback();
      calculateSelection();
    };

    const refreshCart = async () => {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
      const cart = await response.json();
      window.cart = cart;
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart.updated', { detail: cart }));
      return cart;
    };

    const openSideCart = () => {
      if (document.body.classList.contains('template-cart')) {
        // A página pode não ter os blocos de itens quando iniciou vazia.
        // Recarrega o estado confirmado sem repetir as adições.
        window.location.reload();
        return;
      }
      closeDrawer({ restoreFocus: false });
      if (typeof window.forceRefreshSidebarCart === 'function') {
        window.forceRefreshSidebarCart(null, window.cart);
        return;
      }
      if (typeof window.updateCart === 'function') {
        window.updateCart();
        return;
      }
      document.body.classList.add('cart-sidebar-show', 'cart-sidebar-open', 'halo-sidebar-open');
      const sideCart = document.querySelector('#halo-cart-sidebar');
      if (sideCart) sideCart.classList.add('is-open', 'active');
    };

    const addLine = async ({ variantId, quantity }) => {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!response.ok) {
        let message = 'Não foi possível adicionar este produto.';
        try {
          const error = await response.json();
          message = error.description || error.message || message;
        } catch (error) {
          // Mantém a mensagem segura quando a resposta não é JSON.
        }
        throw new Error(message);
      }

      return response.json();
    };

    const addSelection = async () => {
      if (adding || addButton.disabled) return;

      const selected = getInputs()
        .map((input) => ({
          input,
          variantId: Number.parseInt(input.closest('cart-update-compra-rapida').dataset.variant, 10),
          quantity: Number.parseInt(input.value, 10) || 0
        }))
        .filter((item) => item.quantity > 0);

      if (!selected.length) return;

      adding = true;
      resetFeedback();
      calculateSelection();
      announce(`Adicionando ${selected.reduce((sum, item) => sum + item.quantity, 0)} itens ao carrinho.`);

      let successCount = 0;
      const failures = [];

      for (const item of selected) {
        try {
          await addLine(item);
          successCount += item.quantity;
          item.input.value = '0';
          syncQuantityState(item.input);
        } catch (error) {
          failures.push({ item, message: error.message });
        }
      }

      try {
        if (successCount > 0) await refreshCart();
      } catch (error) {
        failures.push({ message: error.message });
      }

      adding = false;
      calculateSelection();
      feedback.hidden = false;

      if (!failures.length) {
        const word = successCount === 1 ? 'item adicionado' : 'itens adicionados';
        feedbackMessage.textContent = `✓ ${successCount} ${word} ao carrinho`;
        feedbackActions.hidden = false;
        announce(feedbackMessage.textContent);
        openSideCart();
      } else {
        const addedText = successCount > 0
          ? `${successCount} ${successCount === 1 ? 'item adicionado' : 'itens adicionados'}. `
          : '';
        const failureCount = failures.filter((failure) => failure.item).length;
        feedbackMessage.textContent = `${addedText}${failureCount || 1} ${failureCount === 1 ? 'item não pôde' : 'itens não puderam'} ser adicionado. Revise a seleção e tente novamente.`;
        feedbackActions.hidden = successCount === 0;
        announce(feedbackMessage.textContent);
      }
    };

    drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-quick-order-retry]')) {
        jobs.filter((job) => job.state === 'error').forEach((job) => {
          job.section.querySelector('.section-products')?.replaceChildren();
          job.section.hidden = true;
          job.state = 'queued';
          job.rows = [];
          job.cursor = 0;
          job.error = null;
        });
        loadingPromise = null;
        loadingFinalized = false;
        updateLoadingState();
        calculateSelection();
        ensureContent({ priority: isOpen() ? 'user-visible' : 'background' })
          .then(finishOpenWhenReady);
        return;
      }

      const categoryScrollControl = event.target.closest('[data-category-scroll-direction]');
      if (categoryScrollControl && categoryNavigation) {
        const direction = Number(categoryScrollControl.dataset.categoryScrollDirection) || 0;
        categoryNavigation.scrollBy({
          left: Math.round(categoryNavigation.clientWidth * .7) * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
        return;
      }

      const category = event.target.closest('.seletor-compra');
      if (category) {
        setCategory(category.dataset.targetSection);
        return;
      }

      const variantToggle = event.target.closest('[data-variant-toggle]');
      if (variantToggle) {
        const variants = document.getElementById(variantToggle.getAttribute('aria-controls'));
        const expanded = variantToggle.getAttribute('aria-expanded') === 'true';
        variantToggle.setAttribute('aria-expanded', String(!expanded));
        if (variants) variants.hidden = expanded;
        return;
      }

      const plus = event.target.closest('[data-plus-quantity-cart]');
      if (plus) {
        changeQuantity(plus, 1);
        return;
      }

      const minus = event.target.closest('[data-minus-quantity-cart]');
      if (minus) {
        changeQuantity(minus, -1);
        return;
      }

      if (event.target.closest('[data-clear-selection]')) {
        getInputs().forEach((input) => {
          input.value = '0';
          syncQuantityState(input);
        });
        resetFeedback();
        calculateSelection();
        announce('Seleção limpa.');
        return;
      }

      if (event.target.closest('[data-clear-search]')) {
        searchInput.value = '';
        applyFilters();
        searchInput.focus();
        return;
      }

      if (event.target.closest('[compra-rapida-add]')) {
        addSelection();
        return;
      }

      if (event.target.closest('[fechar-compra-rapida]')) {
        closeDrawer();
      }
    });

    searchInput.addEventListener('input', applyFilters);
    mobileLayout.addEventListener?.('change', () => {
      calculateSelection();
      requestCategoryScrollbarSync();
    });

    let categoryScrollbarTouchActive = false;
    categoryScrollbar?.addEventListener('input', () => {
      if (categoryScrollbarTouchActive) return;
      categoryNavigation.scrollLeft = Number(categoryScrollbar.value) || 0;
    });

    /**
     * No toque, o range nativo interpreta a posição como absoluta e pode
     * saltar entre os extremos. O arrasto relativo amortecido permite
     * avançar aos poucos e repetir o gesto para percorrer toda a faixa.
     */
    const bindFooterActionPress = () => {
      const actionBar = drawer.querySelector('.footer-compra-rapida-actions');
      if (!actionBar) return;

      let pressedButton = null;

      const releasePressedButton = () => {
        pressedButton?.classList.remove('is-pressed');
        pressedButton = null;
      };

      actionBar.addEventListener('pointerdown', (event) => {
        if (!mobileLayout.matches) return;
        const button = event.target.closest('button:not(:disabled)');
        if (!button || !actionBar.contains(button)) return;
        releasePressedButton();
        pressedButton = button;
        pressedButton.classList.add('is-pressed');
      });

      document.addEventListener('pointerup', releasePressedButton, true);
      document.addEventListener('pointercancel', releasePressedButton, true);
      window.addEventListener('blur', releasePressedButton);
    };

    const bindCategoryScrollbarTouchDrag = () => {
      if (!categoryScrollbar || !categoryNavigation) return;

      const TOUCH_SCROLL_RATIO = .75;
      let pointerId = null;
      let startX = 0;
      let startScroll = 0;

      const endDrag = (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;
        const activePointerId = pointerId;
        pointerId = null;
        categoryScrollbarTouchActive = false;
        if (categoryScrollbar.hasPointerCapture?.(activePointerId)) {
          categoryScrollbar.releasePointerCapture(activePointerId);
        }
        requestCategoryScrollbarSync();
      };

      categoryScrollbar.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || pointerId !== null) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScroll = categoryNavigation.scrollLeft;
        categoryScrollbarTouchActive = true;
        categoryScrollbar.setPointerCapture(pointerId);
        event.preventDefault();
      });

      categoryScrollbar.addEventListener('pointermove', (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;
        event.preventDefault();
        categoryNavigation.scrollLeft = startScroll + ((event.clientX - startX) * TOUCH_SCROLL_RATIO);
      });

      categoryScrollbar.addEventListener('pointerup', endDrag);
      categoryScrollbar.addEventListener('pointercancel', endDrag);
      categoryScrollbar.addEventListener('lostpointercapture', endDrag);
    };

    /**
     * Arrastar a faixa de categorias com o ponteiro para rolar.
     * O toque já rola nativamente, então só mouse e caneta entram aqui.
     * Um limiar de 4px separa arrasto de clique: abaixo dele o clique segue
     * normal e troca a categoria; acima, o clique final é engolido para o
     * arrasto não selecionar a categoria onde o ponteiro parou.
     */
    const bindCategoryDrag = () => {
      if (!categoryNavigation) return;

      const THRESHOLD = 4;
      let pointerId = null;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      const endDrag = () => {
        if (pointerId === null) return;
        if (moved && categoryNavigation.hasPointerCapture?.(pointerId)) {
          categoryNavigation.releasePointerCapture(pointerId);
        }
        if (moved) {
          categoryNavigation.addEventListener(
            'click',
            (event) => {
              event.stopPropagation();
              event.preventDefault();
            },
            { capture: true, once: true }
          );
        }
        pointerId = null;
        moved = false;
        categoryNavigation.classList.remove('is-grabbing');
        requestCategoryScrollbarSync();
      };

      categoryNavigation.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScroll = categoryNavigation.scrollLeft;
        moved = false;
      });

      categoryNavigation.addEventListener('pointermove', (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;
        const delta = event.clientX - startX;
        if (!moved) {
          if (Math.abs(delta) < THRESHOLD) return;
          moved = true;
          categoryNavigation.classList.add('is-grabbing');
          categoryNavigation.setPointerCapture(pointerId);
        }
        event.preventDefault();
        categoryNavigation.scrollLeft = startScroll - delta;
      });

      categoryNavigation.addEventListener('pointerup', endDrag);
      categoryNavigation.addEventListener('pointercancel', endDrag);
      categoryNavigation.addEventListener('dragstart', (event) => event.preventDefault());
    };

    bindFooterActionPress();
    bindCategoryScrollbarTouchDrag();
    bindCategoryDrag();
    categoryNavigation?.addEventListener('scroll', requestCategoryScrollbarSync, { passive: true });
    window.addEventListener('resize', requestCategoryScrollbarSync);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[href="#compra-rapida"], #compra-rapida-trigger');
      if (trigger) {
        event.preventDefault();
        openDrawer(trigger);
        return;
      }

      if (
        document.body.classList.contains('compra-rapida-aberto')
        && event.target.classList.contains('background-overlay')
      ) {
        closeDrawer();
      }
    });

    const intentTrigger = (target) => target?.closest?.('[href="#compra-rapida"], #compra-rapida-trigger');
    const promoteFromIntent = (event) => {
      if (event.type === 'pointerdown' && event.pointerType === 'touch') return;
      if (intentTrigger(event.target)) ensureContent({ priority: 'user-visible' });
    };
    document.addEventListener('pointerover', (event) => {
      if (intentTrigger(event.target) && backgroundAllowed()) ensureContent();
    }, { passive: true });
    document.addEventListener('pointerdown', promoteFromIntent, { passive: true });
    document.addEventListener('touchstart', promoteFromIntent, { passive: true });

    document.addEventListener('focusin', (event) => {
      if (intentTrigger(event.target) && backgroundAllowed()) ensureContent();
      if (
        document.body.classList.contains('compra-rapida-aberto')
        && !event.target.closest?.('.introjs-tooltip, .introjs-overlay, .introjs-helperLayer')
        && !drawer.contains(event.target)
      ) {
        drawer.querySelector('[fechar-compra-rapida]')?.focus();
      }
    });

    const handleMediaState = (event) => {
      if (!(event.target instanceof HTMLMediaElement)) return;
      if ((event.type === 'waiting' || event.type === 'stalled') && !event.target.paused) {
        bufferingMedia.add(event.target);
      }
      if (['playing', 'canplay', 'canplaythrough', 'pause', 'ended', 'error', 'abort', 'emptied'].includes(event.type)) {
        bufferingMedia.delete(event.target);
      }
      mediaBlocksBackground();
      if (!mediaBuffering && !allSettled()) ensureContent({ priority: urgent ? 'user-visible' : 'background' });
    };
    ['play', 'playing', 'waiting', 'stalled', 'canplay', 'canplaythrough', 'pause', 'ended', 'error', 'abort', 'emptied'].forEach((eventName) => {
      document.addEventListener(eventName, handleMediaState, true);
    });

    document.addEventListener('keydown', (event) => {
      if (!document.body.classList.contains('compra-rapida-aberto')) return;
      if (document.querySelector('.introjs-tooltip')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    getInputs().forEach(syncQuantityState);
    updateLoadingState();
    calculateSelection();
    requestCategoryScrollbarSync();

    const startBackgroundLoad = () => {
      if (backgroundAllowed()) ensureContent();
    };
    if (pageLoaded) startBackgroundLoad();
    else {
      window.addEventListener('load', () => {
        pageLoaded = true;
        startBackgroundLoad();
      }, { once: true });
    }
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && !allSettled()) startBackgroundLoad();
    });
    window.addEventListener('online', () => {
      if (!allSettled()) startBackgroundLoad();
    });
    connection?.addEventListener?.('change', () => {
      if (!allSettled() && backgroundAllowed()) startBackgroundLoad();
    });

    if (document.querySelector('#compra-rapida-trigger.not-initialized')) {
      const trigger = document.querySelector('#compra-rapida-trigger.not-initialized');
      trigger.classList.remove('not-initialized');
      trigger.classList.add('initialized');
      window.setTimeout(() => trigger.classList.add('animate'), 1500);
      window.setTimeout(() => trigger.classList.remove('animate'), 6000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickOrder, { once: true });
  } else {
    initQuickOrder();
  }
})();
